module.exports = __webpack_public_path__ + "img/jhaoho_icon.8c72e233.png";